module.exports = __webpack_public_path__ + "img/app-icon.d14b64da.png";